import create from 'zustand';

type CompanyStoreType = {
  company?: Company
  refetch: () => void
  isFetching: boolean
  setCompany: (_company: Company) => void,
  setIsFetching: (_isFetching: boolean) => void,
  setRefetch: (_refetch: () => void) => void,
}

const useCompany = create<CompanyStoreType>(
  (set) => ({
    company: {} as Company,
    refetch: () => null,
    isFetching: false,
    setCompany: (company: Company) => set({ company }),
    setIsFetching: (isFetching: boolean) => set({ isFetching }),
    setRefetch: (refetch: () => void) => set({ refetch }),
  }),
);

export default useCompany;
